import { PaymentMethod } from 'modules/purchase/constants'
import { TPaymentRequestPaymentMethod } from 'modules/purchase/types'

import { CountryCode } from 'root-constants'

const COUNTRIES_WITHOUT_WALLET: Record<TPaymentRequestPaymentMethod, string[]> =
  {
    [PaymentMethod.APPLE_PAY]: [CountryCode.INDIA],
    [PaymentMethod.GOOGLE_PAY]: [CountryCode.TURKEY, CountryCode.INDIA],
  }

export const isWalletAvailableByCountry = (
  paymentMethod: TPaymentRequestPaymentMethod,
  countryCode: string,
): boolean =>
  !COUNTRIES_WITHOUT_WALLET[paymentMethod].includes(countryCode.toLowerCase())
